import type { ReactNode } from 'react'

import { useSession } from '../auth/useSession'

/**
 * Gerbang peran. Viewer tidak melihat kontrol yang mengubah data; server tetap
 * menolaknya dengan 403, jadi ini hanya menyembunyikan aksi yang pasti gagal.
 */
export function CanWrite({ children }: { children: ReactNode }) {
  const { canWrite } = useSession()
  if (!canWrite) {
    return null
  }
  return <>{children}</>
}

/** Keterangan untuk viewer di halaman yang punya aksi tulis. */
export function ViewerNotice() {
  const { canWrite } = useSession()
  if (canWrite) {
    return null
  }
  return (
    <p className="muted">
      Peran viewer hanya bisa membaca. Kontrol yang mengubah data disembunyikan, dan
      server tetap menolak aksi tulis dari akun viewer dengan kode 403.
    </p>
  )
}
